import mutations from './mutations';
import actions from './actions';

const defaultState = () => ({
  tokenList: [],
  isFetchTokenListLoading: false,
  fetchTokenListError: null,
  isCreateTokenLoading: false,
  createTokenError: null,
  isDeleteTokenLoading: false,
  deleteTokenError: null,
  flashToken: null
});

const state = defaultState();

export default {
  actions,
  mutations,
  state,
  namespaced: true
};
